import styled from 'styled-components';

import { useTranslation } from '#/features/localization/utils';

import { cFFFFFF } from '#/colors';
import { useLabelId } from '#/utils/useLabel';
import Field from '#/components/shared/Field';

export default function InputAsset() {
  const labelId = useLabelId('asset');
  const { t } = useTranslation();

  return (
    <Field label={t('Asset')} labelId={labelId}>
      <Value id={labelId}>
        <span>USD Coin</span>
        <span css="opacity: 0.5;">USDC</span>
      </Value>
    </Field>
  );
}

const Value = styled.div`
  background-color: transparent;
  border: none;
  color: ${cFFFFFF};
  font-size: 14px;
  display: flex;
  gap: 10px;
`;
